import { graphql, useStaticQuery } from 'gatsby';

const GQL_FETCH_SITES = graphql`
  {
    allBwSite {
      nodes {
        data
      }
    }
  }
`;

export default function useFetchSites() {
  const { allBwSite } = useStaticQuery(GQL_FETCH_SITES);

  return {
    sites: allBwSite.nodes.map((node) => node.data),
  };
}
